import { render, staticRenderFns } from "./TableOther.vue?vue&type=template&id=67f6aed6"
import script from "./TableOther.vue?vue&type=script&lang=js"
export * from "./TableOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports